define('Responsive/adapters/ModalAdapter',['require','exports','module','../util/dom'],function(require,exports,module){
	var $ReDom=require('../util/dom');

	var doc=document,
		modalClassName="responsive-view-modal",
		fullscreenModalClassName="responsive-view-modal-fullscreen";

	function ModalAdapter(_parent,_view,_anchor){
		this.parent=_parent;
		this.view=_view || _parent;
		this.anchor=_anchor && _anchor.getView() || doc.body;
		this.container = doc.createElement('div');
		if(this.parent.modalView){
			this.clean();
		}
		this.container.className=[modalClassName,(this.anchor===doc.body ? fullscreenModalClassName : ""),"responsive-app"].join(" ");
	}

	ModalAdapter.prototype={
		clean  : function(){
			var modal=this.parent.modalView,
				modalController = modal.getController();

			$ReDom.removeNode(modal.getContainer());
			modalController.viewDidUnload();
			modalController.parentViewController=null;
			modalController.setIsInModal(false);
			parent.modalView=null;
		},
		

		create : function(){
			this.view.setIsInModal(true);
			if(this.view.isViewLoaded() && this.view.getView()===this.anchor){
				return;
			}
			this.view.parentViewController=this.parent;
			this.view.viewWillAppear();
			this.container.appendChild(this.view.getView());
			this.anchor.appendChild(this.container);
			return this;
		},

		destroy			: function(){
			this.hide();
			this.clean();
			this.container=null;
		},

		hide : function(){
			var modal=this.parent.modalView;

			modal.getController().viewWillDisappear();
			modal.getController().viewDidDisappear();
			return this;
		},

		show 			: function(transition){
			this.view.viewDidAppear();

			return this;
		},

		getAnchor		: function(){
			return this.anchor;	
		},
		getContainer	: function(){
			return this.container;	
		},

		getController 	: function(){
			return this.view
		},
		getView 		: function(){
			return this.view.getView();
		},
		getModal	: function(){
			return this.parent.modalView;
		}
	}
	return ModalAdapter;
});
